import { useState } from "react";

import { useTranslation } from "react-i18next";

import { noop } from "lodash";
import { useAuth } from "@/context/Auth/AuthProvider";
import { USER_PERMISSIONS } from "@/roles/types/enums";

import Dialog from "../../../../../../components/Dialog/Dialog";
import { DialogWidth } from "../../../../../../components/Dialog/types/enums";
import { useMediaQueries } from "../../../../../../shared";
import DialogActions from "../../../../../../shared/components/buttons/DialogActions";
import { CreditsDto } from "../../../types";
import HistoryDialogContent from "../HistoryDialogContent/HistoryDialogContent";
import GenerateReportDialog from "./GenerateReport/GenerateReportDialog";

interface HistoryDialogProps {
  open: boolean;
  onClose: () => void;
  creditsData: CreditsDto;
}

const HistoryDialog = ({ open, onClose, creditsData }: HistoryDialogProps) => {
  const { t } = useTranslation();
  const { toMd } = useMediaQueries();

  const { getAccessStatus } = useAuth();

  const canManageCreditReport = getAccessStatus(
    USER_PERMISSIONS.ManageCreditReport
  );

  const [isGenerateReportOpen, setIsGenerateReportOpen] = useState(false);

  const handleOpenGenerateReport = () => {
    setIsGenerateReportOpen(true);
  };

  const descriptionBasedOnPermissions = canManageCreditReport
    ? "description generate report"
    : "description";

  return (
    <>
      <Dialog
        open={open}
        close={onClose}
        title={t("Dialog##credits history##title")}
        description={t(
          `Dialog##credits history##${descriptionBasedOnPermissions}`
        )}
        submit={canManageCreditReport ? handleOpenGenerateReport : noop}
        isTitleSeparator
        isActionsSeparator
        actions={
          <DialogActions
            onClose={onClose}
            confirmationButtonText={t("Button##generate report")}
            cancelButtonText={t("Button##close")}
            isLoading={false}
            isreadyToConfirm
            hideAcceptButton={!canManageCreditReport}
          />
        }
        extendToMaxWidth={toMd}
        width={toMd ? undefined : DialogWidth.MaxWidth}
      >
        <HistoryDialogContent creditsData={creditsData} />
      </Dialog>

      {isGenerateReportOpen && (
        <GenerateReportDialog
          toMd={toMd}
          isOpen={isGenerateReportOpen}
          setIsOpen={setIsGenerateReportOpen}
        />
      )}
    </>
  );
};

export default HistoryDialog;
